export default __webpack_public_path__ + "./images/kg.5c9087dd.png";